import React from 'react';
import './meeting info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message } from "antd";
import moment from 'moment';
class meetingInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    page: 1,
    pages: 1,
    id: this.props.location.state.data.id,
    clientName: this.props.location.state.data.clientName ? this.props.location.state.data.clientName : '',
    clientPhone: this.props.location.state.data.clientPhone ? this.props.location.state.data.clientPhone : '',
    salesName: this.props.location.state.data.salesName ? this.props.location.state.data.salesName : '',
    salesPhone: this.props.location.state.data.salesPhone ? this.props.location.state.data.salesPhone : '',
    createdAt: this.props.location.state.data.createdAt,
    status: this.props.location.state.data.status,
    idCardImg: this.props.location.state.data.idCardImg,
    broker: this.props.location.state.data.broker,
    company:this.props.location.state.data.company? this.props.location.state.data.company.name : '',
    project:this.props.location.state.data.project? this.props.location.state.data.project.name : '',
  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  update = () => {
    const { clientName, clientPhone, salesName, salesPhone } = this.state
    if (hasValue(clientName) && hasValue(clientPhone) && hasValue(salesName) && hasValue(salesPhone)) {
      let l = message.loading('Wait..', 2.5)
      const data = {
        'clientName': clientName,
        'clientPhone': clientPhone,
        'salesName': salesName,
        'salesPhone': salesPhone,
        
      }
      axios.put(`${BASE_END_POINT}meetings/${this.props.location.state.data.id}`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en',
        },
      })
        .then(response => {
          console.log("client UPDATED  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          if (error.response.data.errors.msg[0].msg) {
            l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))

          } else {
            l.then(() => message.error(allStrings.error, 2.5))

          }
        })
    }
  }

  delete = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}meetings/${this.props.location.state.data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    })
      .then(response => {
        console.log("meeting DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  accept = () => {
    let l = message.loading('Wait..', 2.5)
    axios.put(`${BASE_END_POINT}meetings/${this.props.location.state.data.id}/accept`, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    })
      .then(response => {
        console.log("meeting accept")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  reject = () => {
    let l = message.loading('Wait..', 2.5)
    axios.put(`${BASE_END_POINT}meetings/${this.props.location.state.data.id}/reject`, { dealCost: this.state.dealCost }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    })
      .then(response => {
        console.log("meeting reject")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }

  submitHandler = event => {
    event.preventDefault();
    console.log(event.target.className)
    event.target.className += " was-validated";
    this.update()
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('MEETINGS')) return <Redirect to='/Home' />
    return (
      <div className="App">
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <div className="infoCard">
                <Card className="editCard">
                  <CardMedia
                    style={{ height: "0px" }}
                  />
                  <CardHeader></CardHeader>
                  <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                    <div className="topIcon">
                      <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>meeting_room</span>
                    </div>
                    <div className="tableTitle" style={{
                      display: this.props.isRTL ? 'inline-block' : 'inline-block', marginTop: this.props.isRTL ? '-60px' : '-60px',
                      marginLeft: this.props.isRTL ? '0' : '7.5rem', marginRight: this.props.isRTL ? '8.5rem' : '0'
                    }}>
                      <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                    </div>
                  </div>
                  <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                    <MDBContainer>

                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >
                            <div className="grey-text">
                              {this.state.actionType === "VIEW" &&
                                <MDBRow>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form6015" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.id} type="text" id="form6015" className="form-control" />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form6005" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.status === "PENDING" ? allStrings.pending : this.state.status === "ACCEPTED" ? allStrings.accepted : allStrings.rejected} type="text" id="form6005" className="form-control" />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>

                                </MDBRow>
                              }

                              <MDBRow>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientName}</label>
                                    <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.clientName} type="text" id="form645" name="clientName" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientPhone}</label>
                                    <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.clientPhone} type="text" id="form56" name="clientPhone" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                                    <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.project} type="text" id="form645" name="project" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.company}</label>
                                    <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.company} type="text" id="form56" name="company" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form516" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.salesName}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.salesName} type="text" id="form516" name="salesName" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form625" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.salesPhone}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.salesPhone} type="text" id="form625" name="salesPhone" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              {this.state.actionType === "VIEW" && this.state.createdAt &&
                                <MDBRow>
                                  <MDBCol md="12">
                                    <div className="md-form">
                                      <label htmlFor="form062" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={moment(this.state.createdAt).format('lll')} type="text" id="form062" className="form-control" validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                              }
                              {this.state.actionType === "VIEW" &&
                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                  <MDBCol md="10" xs="10">
                                    <div class="md-form">
                                      <label for="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.broker}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.broker ? this.state.broker.fullname : ''} type="text" id="form80" class="form-control" />
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="2" xs="2">

                                    <p style={{ textAlign: 'center', marginTop: '2rem', color: '#2BBBAD' }}>
                                      <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                        onClick={() => { this.props.history.push('userInfo', { data: this.state.broker, actionType: 'VIEW' }) }}>
                                        remove_red_eye
                                      </span>
                                      <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                        onClick={() => { this.props.history.push('userInfo', { data: this.state.broker }) }}>
                                        {allStrings.show}
                                      </span>
                                    </p>
                                  </MDBCol>
                                </MDBRow>
                              }
                              {this.state.actionType === "VIEW" && this.state.idCardImg != null &&
                                <div>
                                  <label htmlFor="form062" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.idCardImg}</label>
                                  <div>
                                    <a href={this.state.idCardImg} target="blank" style={{
                                      background: 'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',
                                      color: '#fff',
                                      padding: '3px 40px',
                                      marginLeft: '15px'
                                    }}
                                    >
                                      {allStrings.openFile}
                                    </a>
                                  </div>
                                </div>
                              }


                            </div>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                              {this.state.actionType === "EDIT" &&
                                <MDBBtn
                                  style={{ background: '#E6B659', color: '#fff' }}
                                  rounded
                                  color="#E6B659"
                                  type="submit"
                                  className="btn-block z-depth-1a"
                                >
                                  <MDBIcon icon="edit" className="mr-2" />
                                  {allStrings.update}
                                </MDBBtn>
                              }{this.state.actionType === "VIEW" && this.state.actionType === "VIEW" &&
                                <MDBBtn onClick={() => { this.delete() }} rounded color="danger" className="btn-block z-depth-1a">
                                  <MDBIcon icon="trash-alt" className="mr-2" />
                                  {allStrings.remove}
                                </MDBBtn>
                              }
                              {this.state.status === "PENDING" && this.state.actionType === "VIEW" &&
                                <MDBBtn onClick={() => { this.accept() }} rounded color="green" className="btn-block z-depth-1a">
                                  <MDBIcon className="mr-2" />
                                  {allStrings.accept}
                                </MDBBtn>
                              }
                              {this.state.status === "PENDING" && this.state.actionType === "VIEW" &&
                                <MDBBtn onClick={() => { this.reject() }} rounded className="btn-block z-depth-1a">
                                  <MDBIcon className="mr-2" />
                                  {allStrings.reject}
                                </MDBBtn>
                              }

                            </div>
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </CardContent>
                </Card>
              </div>
            </MDBCol>
          </MDBRow>

        </MDBContainer>

      </div>
    )
  }
}


const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(meetingInfo)
);